module.exports = __webpack_public_path__ + "static/media/twitter.9d99a237.ico";